// src/components/learning/islamic/FivePillars.js
// Interface ludique pour apprendre les 5 piliers de l'Islam

import React, { useState } from 'react';
import { pillarsData, quizEncouragements, pillarsBadge } from './pillarsData';
import Confetti, { Trophy } from '../Confetti';
import { playArabic } from '../../../utils/audioPlayer';

const FivePillars = ({ onClose }) => {
  const [selectedPillar, setSelectedPillar] = useState(null);
  const [showQuiz, setShowQuiz] = useState(false);
  const [quizState, setQuizState] = useState({
    currentQuestion: 0,
    score: 0,
    answers: [],
    showResult: false
  });
  const [showConfetti, setShowConfetti] = useState(false);
  const [showTrophy, setShowTrophy] = useState(false);
  const [feedback, setFeedback] = useState(null);

  // Jouer le son arabe

  // Quiz final - toutes les questions mélangées
  const allQuizQuestions = pillarsData.flatMap(p => 
    p.quiz.map(q => ({ ...q, pillarName: p.name, pillarIcon: p.icon }))
  );

  const handleQuizAnswer = (answer) => {
    const currentQ = allQuizQuestions[quizState.currentQuestion];
    const isCorrect = answer === currentQ.correct;
    
    // Feedback
    if (isCorrect) {
      const msg = quizEncouragements.correct[Math.floor(Math.random() * quizEncouragements.correct.length)];
      setFeedback({ type: 'correct', message: msg });
    } else {
      const msg = quizEncouragements.wrong[Math.floor(Math.random() * quizEncouragements.wrong.length)];
      setFeedback({ type: 'wrong', message: msg, explanation: currentQ.explanation });
    }

    setTimeout(() => {
      setFeedback(null);
      
      const newState = {
        ...quizState,
        score: isCorrect ? quizState.score + 1 : quizState.score,
        answers: [...quizState.answers, { question: currentQ, answer, isCorrect }],
        currentQuestion: quizState.currentQuestion + 1
      };

      if (newState.currentQuestion >= allQuizQuestions.length) {
        newState.showResult = true;
        if (newState.score >= 8) {
          setShowTrophy(true);
          setTimeout(() => setShowConfetti(true), 500);
        } else if (newState.score >= 5) {
          setShowConfetti(true);
        }
      }

      setQuizState(newState);
    }, 1500);
  };

  // Réinitialiser le quiz
  const resetQuiz = () => {
    setQuizState({
      currentQuestion: 0,
      score: 0,
      answers: [],
      showResult: false
    });
    setShowConfetti(false);
    setShowTrophy(false);
  };

  // ==================== VUE QUIZ ====================
  if (showQuiz) {
    // Résultat final
    if (quizState.showResult) {
      const percentage = Math.round((quizState.score / allQuizQuestions.length) * 100);
      const passed = quizState.score >= 8;

      return (
        <div style={{
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.95)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999
        }}>
          {showConfetti && <Confetti type={passed ? 'gold' : 'confetti'} duration={4000} />}
          {showTrophy && <Trophy />}

          <div style={{
            background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
            borderRadius: '24px',
            padding: '3rem',
            textAlign: 'center',
            maxWidth: '500px',
            width: '90%'
          }}>
            <div style={{ fontSize: '6rem', marginBottom: '1rem' }}>
              {passed ? '🏆' : quizState.score >= 5 ? '🌟' : '💪'}
            </div>

            <h2 style={{ color: 'white', fontSize: '2rem', margin: '0 0 1rem 0' }}>
              {passed ? 'Félicitations !' : quizState.score >= 5 ? 'Bien joué !' : 'Continue d\'apprendre !'}
            </h2>

            <div style={{
              background: 'rgba(255,255,255,0.1)',
              borderRadius: '16px',
              padding: '1.5rem',
              marginBottom: '2rem'
            }}>
              <div style={{ fontSize: '3rem', fontWeight: 'bold', color: passed ? '#10b981' : '#f59e0b' }}>
                {quizState.score}/{allQuizQuestions.length}
              </div>
              <div style={{ color: 'rgba(255,255,255,0.7)' }}>
                {percentage}% de bonnes réponses
              </div>
            </div>

            {passed && (
              <div style={{
                background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)',
                borderRadius: '12px',
                padding: '1rem',
                marginBottom: '2rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '1rem'
              }}>
                <span style={{ fontSize: '2rem' }}>🏆</span>
                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontWeight: 'bold', color: '#1f2937' }}>Badge débloqué !</div>
                  <div style={{ fontSize: '0.9rem', color: '#374151' }}>{pillarsBadge.name}</div>
                </div>
              </div>
            )}

            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
              <button
                onClick={resetQuiz}
                style={{
                  padding: '1rem 2rem',
                  borderRadius: '12px',
                  border: 'none',
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white',
                  fontSize: '1rem',
                  fontWeight: 'bold',
                  cursor: 'pointer'
                }}
              >
                🔄 Rejouer
              </button>
              <button
                onClick={() => setShowQuiz(false)}
                style={{
                  padding: '1rem 2rem',
                  borderRadius: '12px',
                  border: '2px solid rgba(255,255,255,0.3)',
                  background: 'transparent',
                  color: 'white',
                  fontSize: '1rem',
                  fontWeight: 'bold',
                  cursor: 'pointer'
                }}
              >
                ← Retour
              </button>
            </div>
          </div>
        </div>
      );
    }

    // Question en cours
    const currentQ = allQuizQuestions[quizState.currentQuestion];

    return (
      <div style={{
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.95)',
        display: 'flex',
        flexDirection: 'column',
        zIndex: 9999
      }}>
        {/* Header */}
        <div style={{
          padding: '1rem 1.5rem',
          background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <span style={{ fontSize: '2rem' }}>📝</span>
            <div>
              <h2 style={{ margin: 0, color: 'white' }}>Quiz des 5 Piliers</h2>
              <p style={{ margin: 0, color: 'rgba(255,255,255,0.6)', fontSize: '0.9rem' }}>
                Question {quizState.currentQuestion + 1}/{allQuizQuestions.length}
              </p>
            </div>
          </div>
          
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <div style={{
              background: 'rgba(16, 185, 129, 0.2)',
              padding: '0.5rem 1rem',
              borderRadius: '8px',
              color: '#10b981',
              fontWeight: 'bold'
            }}>
              ⭐ {quizState.score} pts
            </div>
            <button
              onClick={() => setShowQuiz(false)}
              style={{
                background: 'rgba(255,255,255,0.1)',
                border: 'none',
                borderRadius: '8px',
                padding: '0.5rem 1rem',
                color: 'white',
                cursor: 'pointer'
              }}
            >
              ✕
            </button>
          </div>
        </div>

        {/* Progress bar */}
        <div style={{ height: '4px', background: 'rgba(255,255,255,0.1)' }}>
          <div style={{
            height: '100%',
            width: `${(quizState.currentQuestion / allQuizQuestions.length) * 100}%`,
            background: 'linear-gradient(90deg, #667eea, #764ba2)',
            transition: 'width 0.3s ease'
          }} />
        </div>

        {/* Question */}
        <div style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '2rem',
          gap: '2rem'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            color: 'rgba(255,255,255,0.6)'
          }}>
            <span style={{ fontSize: '1.5rem' }}>{currentQ.pillarIcon}</span>
            <span>{currentQ.pillarName}</span>
          </div>

          <h3 style={{
            color: 'white',
            fontSize: '1.8rem',
            textAlign: 'center',
            maxWidth: '600px',
            margin: 0
          }}>
            {currentQ.question}
          </h3>

          {/* Feedback */}
          {feedback && (
            <div style={{
              padding: '1rem 2rem',
              borderRadius: '12px',
              background: feedback.type === 'correct' ? 'rgba(16, 185, 129, 0.2)' : 'rgba(239, 68, 68, 0.2)',
              color: feedback.type === 'correct' ? '#10b981' : '#ef4444',
              textAlign: 'center'
            }}>
              <div style={{ fontSize: '1.3rem', fontWeight: 'bold' }}>{feedback.message}</div>
              {feedback.explanation && (
                <div style={{ marginTop: '0.5rem', fontSize: '0.9rem', opacity: 0.9 }}>
                  {feedback.explanation}
                </div>
              )}
            </div>
          )}

          {/* Options */}
          {!feedback && (
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              gap: '1rem',
              maxWidth: '600px',
              width: '100%'
            }}>
              {currentQ.options.map((option, index) => (
                <button
                  key={index}
                  onClick={() => handleQuizAnswer(option)}
                  style={{
                    padding: '1.5rem',
                    borderRadius: '16px',
                    border: '3px solid rgba(255,255,255,0.2)',
                    background: 'rgba(255,255,255,0.1)',
                    color: 'white',
                    fontSize: '1.2rem',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.borderColor = '#667eea';
                    e.target.style.transform = 'scale(1.03)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.borderColor = 'rgba(255,255,255,0.2)';
                    e.target.style.transform = 'scale(1)';
                  }}
                >
                  {option}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }

  // ==================== VUE DÉTAIL PILIER ====================
  if (selectedPillar) {
    const pillar = selectedPillar;

    return (
      <div style={{
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.95)',
        zIndex: 9999,
        overflow: 'auto'
      }}>
        {/* Header */}
        <div style={{
          padding: '1.5rem',
          background: pillar.gradient,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <button
              onClick={() => setSelectedPillar(null)}
              style={{
                background: 'rgba(255,255,255,0.2)',
                border: 'none',
                borderRadius: '8px',
                padding: '0.5rem 1rem',
                color: 'white',
                cursor: 'pointer',
                fontSize: '1.2rem'
              }}
            >
              ←
            </button>
            <span style={{ fontSize: '3rem' }}>{pillar.icon}</span>
            <div>
              <h2 style={{ margin: 0, color: 'white', fontSize: '1.5rem' }}>
                {pillar.title}
              </h2>
              <p 
                onClick={() => playArabic(pillar.nameAr)}
                style={{ 
                  margin: 0, 
                  color: 'rgba(255,255,255,0.9)', 
                  fontSize: '1.3rem',
                  fontFamily: "'Amiri', serif",
                  cursor: 'pointer'
                }}
              >
                {pillar.nameAr} 🔊
              </p>
            </div>
          </div>
          
          <button
            onClick={onClose}
            style={{
              background: 'rgba(255,255,255,0.2)',
              border: 'none',
              borderRadius: '50%',
              width: '40px',
              height: '40px',
              color: 'white',
              cursor: 'pointer'
            }}
          >
            ✕
          </button>
        </div>

        {/* Contenu */}
        <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto' }}>
          {/* Introduction */}
          <div style={{
            background: 'rgba(255,255,255,0.1)',
            borderRadius: '16px',
            padding: '1.5rem',
            marginBottom: '2rem'
          }}>
            <p style={{ color: 'white', fontSize: '1.2rem', margin: 0, lineHeight: 1.6 }}>
              {pillar.content.intro}
            </p>
          </div>

          {/* Contenu spécifique selon le pilier */}
          {pillar.name === 'Shahada' && (
            <>
              {/* Texte arabe */}
              <div style={{
                background: pillar.gradient,
                borderRadius: '16px',
                padding: '2rem',
                textAlign: 'center',
                marginBottom: '2rem'
              }}>
                <div 
                  onClick={() => playArabic(pillar.content.arabicText)}
                  style={{
                    fontSize: '2rem',
                    fontFamily: "'Amiri', serif",
                    color: 'white',
                    marginBottom: '1rem',
                    cursor: 'pointer',
                    lineHeight: 1.8
                  }}
                >
                  {pillar.content.arabicText} 🔊
                </div>
                <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: '1rem', marginBottom: '0.5rem' }}>
                  {pillar.content.transliteration}
                </div>
                <div style={{ color: 'rgba(255,255,255,0.9)', fontSize: '1.1rem', fontStyle: 'italic' }}>
                  "{pillar.content.translation}"
                </div>
              </div>

              {/* Les deux parties */}
              <h3 style={{ color: 'white', marginBottom: '1rem' }}>📖 Les deux parties :</h3>
              <div style={{ display: 'grid', gap: '1rem', marginBottom: '2rem' }}>
                {pillar.content.parts.map((part, i) => (
                  <div key={i} style={{
                    background: 'rgba(255,255,255,0.1)',
                    borderRadius: '12px',
                    padding: '1.5rem',
                    borderLeft: `4px solid ${pillar.color}`
                  }}>
                    <div 
                      onClick={() => playArabic(part.arabic)}
                      style={{
                        fontSize: '1.5rem',
                        fontFamily: "'Amiri', serif",
                        color: pillar.color,
                        marginBottom: '0.5rem',
                        cursor: 'pointer'
                      }}
                    >
                      {part.arabic} 🔊
                    </div>
                    <div style={{ color: 'white', fontWeight: 'bold', marginBottom: '0.5rem' }}>
                      {part.meaning}
                    </div>
                    <div style={{ color: 'rgba(255,255,255,0.7)' }}>
                      {part.explanation}
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}

          {pillar.name === 'Salat' && (
            <>
              {/* Les 5 prières */}
              <h3 style={{ color: 'white', marginBottom: '1rem' }}>🕌 Les 5 prières quotidiennes :</h3>
              <div style={{ display: 'grid', gap: '1rem', marginBottom: '2rem' }}>
                {pillar.content.prayers.map((prayer, i) => (
                  <div key={i} style={{
                    background: 'rgba(255,255,255,0.1)',
                    borderRadius: '12px',
                    padding: '1.5rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1rem'
                  }}>
                    <div style={{ fontSize: '3rem' }}>{prayer.emoji}</div>
                    <div style={{ flex: 1 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                        <span style={{ color: 'white', fontWeight: 'bold', fontSize: '1.2rem' }}>
                          {prayer.name}
                        </span>
                        <span 
                          onClick={() => playArabic(prayer.nameAr)}
                          style={{ 
                            color: pillar.color, 
                            fontFamily: "'Amiri', serif",
                            cursor: 'pointer'
                          }}
                        >
                          {prayer.nameAr} 🔊
                        </span>
                      </div>
                      <div style={{ color: 'rgba(255,255,255,0.7)' }}>{prayer.time}</div>
                    </div>
                    <div style={{
                      background: pillar.gradient,
                      padding: '0.5rem 1rem',
                      borderRadius: '8px',
                      color: 'white',
                      fontWeight: 'bold'
                    }}>
                      {prayer.rakaat} rakaat
                    </div>
                  </div>
                ))}
              </div>
              
              <div style={{
                background: pillar.gradient,
                borderRadius: '12px',
                padding: '1.5rem',
                textAlign: 'center',
                color: 'white',
                fontSize: '1.2rem',
                marginBottom: '2rem'
              }}>
                🧮 {pillar.content.totalRakaat}
              </div>
            </>
          )}

          {pillar.name === 'Zakat' && (
            <>
              {/* Pourcentage */}
              <div style={{
                background: pillar.gradient,
                borderRadius: '16px',
                padding: '2rem',
                textAlign: 'center',
                marginBottom: '2rem'
              }}>
                <div style={{ fontSize: '4rem', fontWeight: 'bold', color: 'white' }}>
                  {pillar.content.percentage}
                </div>
                <div style={{ color: 'rgba(255,255,255,0.9)', fontSize: '1.1rem' }}>
                  {pillar.content.percentageExplained}
                </div>
              </div>

              {/* Bénéficiaires */}
              <h3 style={{ color: 'white', marginBottom: '1rem' }}>💝 Qui reçoit la Zakat ?</h3>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1rem', marginBottom: '2rem' }}>
                {pillar.content.recipients.map((r, i) => (
                  <div key={i} style={{
                    background: 'rgba(255,255,255,0.1)',
                    borderRadius: '12px',
                    padding: '1.5rem',
                    textAlign: 'center'
                  }}>
                    <div style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>{r.icon}</div>
                    <div style={{ color: 'white', fontWeight: 'bold' }}>{r.name}</div>
                    <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.9rem' }}>{r.description}</div>
                  </div>
                ))}
              </div>
            </>
          )}

          {pillar.name === 'Sawm' && (
            <>
              {/* Le mois */}
              <div style={{
                background: pillar.gradient,
                borderRadius: '16px',
                padding: '2rem',
                textAlign: 'center',
                marginBottom: '2rem'
              }}>
                <div 
                  onClick={() => playArabic(pillar.content.month.nameAr)}
                  style={{ 
                    fontSize: '2.5rem', 
                    fontFamily: "'Amiri', serif", 
                    color: 'white',
                    cursor: 'pointer'
                  }}
                >
                  {pillar.content.month.nameAr} 🔊
                </div>
                <div style={{ color: 'white', fontSize: '1.5rem', fontWeight: 'bold' }}>
                  {pillar.content.month.name}
                </div>
                <div style={{ color: 'rgba(255,255,255,0.8)' }}>
                  {pillar.content.month.position}
                </div>
              </div>

              {/* Journée type */}
              <h3 style={{ color: 'white', marginBottom: '1rem' }}>📅 Une journée de Ramadan :</h3>
              <div style={{ display: 'grid', gap: '1rem', marginBottom: '2rem' }}>
                {pillar.content.schedule.map((item, i) => (
                  <div key={i} style={{
                    background: 'rgba(255,255,255,0.1)',
                    borderRadius: '12px',
                    padding: '1.5rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1rem'
                  }}>
                    <div style={{ fontSize: '2.5rem' }}>{item.emoji}</div>
                    <div>
                      <div style={{ color: pillar.color, fontWeight: 'bold', fontSize: '1.1rem' }}>
                        {item.time}
                      </div>
                      <div style={{ color: 'rgba(255,255,255,0.8)' }}>{item.description}</div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Nuit du Destin */}
              <div style={{
                background: 'linear-gradient(135deg, #1f2937 0%, #111827 100%)',
                borderRadius: '16px',
                padding: '1.5rem',
                marginBottom: '2rem',
                border: '2px solid #fbbf24'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
                  <span style={{ fontSize: '2rem' }}>✨</span>
                  <div>
                    <div style={{ color: '#fbbf24', fontWeight: 'bold', fontSize: '1.2rem' }}>
                      {pillar.content.specialNight.name}
                    </div>
                    <div 
                      onClick={() => playArabic(pillar.content.specialNight.nameAr)}
                      style={{ 
                        color: 'white', 
                        fontFamily: "'Amiri', serif",
                        cursor: 'pointer'
                      }}
                    >
                      {pillar.content.specialNight.nameAr} 🔊
                    </div>
                  </div>
                </div>
                <p style={{ color: 'rgba(255,255,255,0.9)', margin: 0 }}>
                  {pillar.content.specialNight.description}
                </p>
              </div>
            </>
          )}

          {pillar.name === 'Hajj' && (
            <>
              {/* Lieu */}
              <div style={{
                background: pillar.gradient,
                borderRadius: '16px',
                padding: '2rem',
                textAlign: 'center',
                marginBottom: '2rem'
              }}>
                <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🕋</div>
                <div 
                  onClick={() => playArabic(pillar.content.location.cityAr)}
                  style={{ 
                    fontSize: '2rem', 
                    fontFamily: "'Amiri', serif", 
                    color: 'white',
                    cursor: 'pointer'
                  }}
                >
                  {pillar.content.location.cityAr} 🔊
                </div>
                <div style={{ color: 'white', fontSize: '1.3rem' }}>
                  {pillar.content.location.city} - {pillar.content.location.country}
                </div>
              </div>

              {/* Rituels */}
              <h3 style={{ color: 'white', marginBottom: '1rem' }}>🚶 Les étapes du Hajj :</h3>
              <div style={{ display: 'grid', gap: '1rem', marginBottom: '2rem' }}>
                {pillar.content.rituals.map((ritual, i) => (
                  <div key={i} style={{
                    background: 'rgba(255,255,255,0.1)',
                    borderRadius: '12px',
                    padding: '1.5rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1rem'
                  }}>
                    <div style={{
                      background: pillar.gradient,
                      width: '50px',
                      height: '50px',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '1.5rem'
                    }}>
                      {ritual.icon}
                    </div>
                    <div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <span style={{ color: 'white', fontWeight: 'bold' }}>{ritual.name}</span>
                        <span 
                          onClick={() => playArabic(ritual.nameAr)}
                          style={{ 
                            color: 'rgba(255,255,255,0.6)', 
                            fontFamily: "'Amiri', serif",
                            cursor: 'pointer'
                          }}
                        >
                          {ritual.nameAr} 🔊
                        </span>
                      </div>
                      <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.95rem' }}>
                        {ritual.description}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Aïd */}
              <div style={{
                background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)',
                borderRadius: '16px',
                padding: '1.5rem',
                marginBottom: '2rem'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
                  <span style={{ fontSize: '2rem' }}>🎉</span>
                  <div>
                    <div style={{ color: '#1f2937', fontWeight: 'bold', fontSize: '1.2rem' }}>
                      {pillar.content.eid.name}
                    </div>
                    <div style={{ color: '#374151', fontFamily: "'Amiri', serif" }}>
                      {pillar.content.eid.nameAr}
                    </div>
                  </div>
                </div>
                <p style={{ color: '#374151', margin: 0 }}>
                  {pillar.content.eid.description}
                </p>
              </div>
            </>
          )}

          {/* Fun Facts */}
          <h3 style={{ color: 'white', marginBottom: '1rem' }}>✨ Le savais-tu ?</h3>
          <div style={{
            background: 'rgba(255,255,255,0.1)',
            borderRadius: '16px',
            padding: '1.5rem',
            marginBottom: '2rem'
          }}>
            {pillar.content.funFacts.map((fact, i) => (
              <div key={i} style={{
                color: 'white',
                padding: '0.75rem 0',
                borderBottom: i < pillar.content.funFacts.length - 1 ? '1px solid rgba(255,255,255,0.1)' : 'none'
              }}>
                {fact}
              </div>
            ))}
          </div>

          {/* Bouton suivant */}
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
            {pillar.id < 5 && (
              <button
                onClick={() => setSelectedPillar(pillarsData[pillar.id])}
                style={{
                  padding: '1rem 2rem',
                  borderRadius: '12px',
                  border: 'none',
                  background: pillarsData[pillar.id].gradient,
                  color: 'white',
                  fontSize: '1rem',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}
              >
                Suivant : {pillarsData[pillar.id].name} {pillarsData[pillar.id].icon} →
              </button>
            )}
            {pillar.id === 5 && (
              <button
                onClick={() => { setSelectedPillar(null); setShowQuiz(true); }}
                style={{
                  padding: '1rem 2rem',
                  borderRadius: '12px',
                  border: 'none',
                  background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                  color: 'white',
                  fontSize: '1rem',
                  fontWeight: 'bold',
                  cursor: 'pointer'
                }}
              >
                📝 Passer le Quiz !
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  // ==================== VUE PRINCIPALE ====================
  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.95)',
      zIndex: 9999,
      overflow: 'auto'
    }}>
      {/* Header */}
      <div style={{
        padding: '1.5rem',
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
        borderBottom: '2px solid rgba(255,255,255,0.1)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <span style={{ fontSize: '2.5rem' }}>🕌</span>
          <div>
            <h2 style={{ margin: 0, color: 'white', fontSize: '1.5rem' }}>
              Les 5 Piliers de l'Islam
            </h2>
            <p style={{ margin: 0, color: 'rgba(255,255,255,0.7)', fontSize: '1rem' }}>
              أَرْكَانُ الإِسْلَامِ الخَمْسَة
            </p>
          </div>
        </div>
        
        <button
          onClick={onClose}
          style={{
            background: 'rgba(255,255,255,0.1)',
            border: 'none',
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            color: 'white',
            cursor: 'pointer',
            fontSize: '1.2rem'
          }}
        >
          ✕
        </button>
      </div>

      {/* Introduction */}
      <div style={{ padding: '2rem', maxWidth: '900px', margin: '0 auto' }}>
        <div style={{
          background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.2) 0%, rgba(118, 75, 162, 0.2) 100%)',
          borderRadius: '16px',
          padding: '1.5rem',
          marginBottom: '2rem',
          textAlign: 'center'
        }}>
          <p style={{ color: 'white', fontSize: '1.1rem', margin: 0, lineHeight: 1.6 }}>
            L'Islam repose sur <strong>5 piliers</strong> fondamentaux. 
            Ce sont les actions et croyances essentielles pour être musulman.
            Découvre-les un par un ! 🌟
          </p>
        </div>

        {/* Les 5 piliers */}
        <div style={{
          display: 'grid',
          gap: '1.5rem',
          marginBottom: '2rem'
        }}>
          {pillarsData.map((pillar) => (
            <div
              key={pillar.id}
              onClick={() => setSelectedPillar(pillar)}
              style={{
                background: 'rgba(255,255,255,0.05)',
                borderRadius: '16px',
                padding: '1.5rem',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                border: '2px solid transparent',
                display: 'flex',
                alignItems: 'center',
                gap: '1.5rem'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = `${pillar.color}20`;
                e.currentTarget.style.borderColor = pillar.color;
                e.currentTarget.style.transform = 'translateX(10px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.05)';
                e.currentTarget.style.borderColor = 'transparent';
                e.currentTarget.style.transform = 'translateX(0)';
              }}
            >
              {/* Numéro */}
              <div style={{
                background: pillar.gradient,
                width: '60px',
                height: '60px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '1.8rem',
                fontFamily: "'Amiri', serif",
                color: 'white',
                fontWeight: 'bold',
                flexShrink: 0
              }}>
                {pillar.number}
              </div>

              {/* Icône */}
              <div style={{ fontSize: '3rem', flexShrink: 0 }}>
                {pillar.icon}
              </div>

              {/* Contenu */}
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '0.5rem' }}>
                  <h3 style={{ margin: 0, color: 'white', fontSize: '1.3rem' }}>
                    {pillar.name}
                  </h3>
                  <span style={{ 
                    color: pillar.color, 
                    fontFamily: "'Amiri', serif",
                    fontSize: '1.2rem'
                  }}>
                    {pillar.nameAr}
                  </span>
                </div>
                <p style={{ margin: 0, color: 'rgba(255,255,255,0.7)' }}>
                  {pillar.shortDescription}
                </p>
              </div>

              {/* Flèche */}
              <div style={{ color: pillar.color, fontSize: '1.5rem' }}>→</div>
            </div>
          ))}
        </div>

        {/* Bouton Quiz */}
        <div style={{ textAlign: 'center' }}>
          <button
            onClick={() => setShowQuiz(true)}
            style={{
              padding: '1.5rem 3rem',
              borderRadius: '16px',
              border: 'none',
              background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
              color: 'white',
              fontSize: '1.2rem',
              fontWeight: 'bold',
              cursor: 'pointer',
              boxShadow: '0 10px 30px rgba(16, 185, 129, 0.3)'
            }}
            onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
            onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
          >
            📝 Tester mes connaissances
          </button>
          <p style={{ color: 'rgba(255,255,255,0.5)', marginTop: '1rem' }}>
            10 questions pour gagner le badge 🏆
          </p>
        </div>
      </div>
    </div>
  );
};

export default FivePillars;
